module.exports = __webpack_public_path__ + "img/sucot.038da80e.jpeg";